"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toUtcDate = exports.toDate = exports.toNumber = exports.withSeparator = exports.withToman = exports.fixDateTime = exports.withNumbers = void 0;
const numeral_1 = __importDefault(require("numeral"));
const moment_jalaali_1 = __importDefault(require("moment-jalaali"));
const ARABIC_NUMBERS_REGEXP = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];
const PERSIAN_NUMBERS_REGEXP = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g];
function withNumbers(fn) {
    return (value) => {
        for (var i = 0; i < 10; i++) {
            const number = i.toString();
            value = value.replace(ARABIC_NUMBERS_REGEXP[i], number).replace(PERSIAN_NUMBERS_REGEXP[i], number);
        }
        return fn(value);
    };
}
exports.withNumbers = withNumbers;
function fixDateTime(value, options) {
    const { displayTime = true } = options || {};
    const dateTimeArray = value.split(' ');
    if (!displayTime)
        dateTimeArray.pop();
    return dateTimeArray.reverse().join(' | ');
}
exports.fixDateTime = fixDateTime;
const withToman = (price = 0) => {
    let numberPrice;
    if (typeof price === 'string') {
        numberPrice = parseFloat(price.replace(/,/g, ''));
    }
    else {
        numberPrice = price;
    }
    numberPrice = numberPrice / 10;
    return `${withSeparator(numberPrice)} تومان`;
};
exports.withToman = withToman;
function withSeparator(value) {
    if (typeof value === 'undefined')
        return;
    else if (typeof value === 'string')
        value = parseFloat(value.replace(/,/g, ''));
    return numeral_1.default(value).format('0,0.[000]');
}
exports.withSeparator = withSeparator;
function toNumber(value) {
    return parseFloat(value.replace(/,/g, ''));
}
exports.toNumber = toNumber;
const toDate = (date, format = 'jYYYY/jMM/jDD HH:mm:ss') => {
    return moment_jalaali_1.default(date, format).toDate();
};
exports.toDate = toDate;
const toUtcDate = (date, format = 'jYYYY/jMM/jDD HH:mm:ss') => {
    return moment_jalaali_1.default.utc(date, format).toDate();
};
exports.toUtcDate = toUtcDate;
